import { Session } from '../../framework/frontend/Session';
import { AuthUser } from '../../server/dto/AuthUser';

const SESSION_USER = 'session_user';

export const PLAN_KEY_VALUES = {
  free: 'free',
  standard: 'standard',
  enterprise: 'enterprise',
  teacher: 'teacher',
  pro: 'pro',
  admin: 'admin',
} as const;
export type PLAN_KEY = keyof typeof PLAN_KEY_VALUES;

/**
 * Sessionのユーザー情報を操作するクラス
 * saveAuthUserInSessionでログインやアカウント作成時にサーバーに保存したユーザーデータを持つ。
 * 以降、getInstanceで本インスタンスを操作できる。
 */
export class SessionUser extends Session {
  private authUser: AuthUser = null;
  /**
   * 隠蔽したコンストラクタ、static getInstanceを利用してインスタンス取得すること
   * @param user
   */
  private constructor(user: AuthUser) {
    super();
    this.authUser = user;
  }

  /**
   * ログインやアカウント作成時に利用するユーザー情報のセッション保持メソッド
   * @param user
   * @returns
   */
  static saveAuthUserInSession(user: AuthUser): SessionUser {
    sessionStorage.setItem(SESSION_USER, JSON.stringify(user));
    return new SessionUser(user);
  }

  /**
   * セッションにユーザー情報があればtrue
   */
  static get isAuthorized(): boolean {
    return sessionStorage.getItem(SESSION_USER) ? true : false;
  }

  /**
   * セッションユーザーインスタンスを取得
   */
  static get instance(): SessionUser | null {
    const json = sessionStorage.getItem(SESSION_USER);
    if (json) {
      const authUser: AuthUser = JSON.parse(json);
      return new SessionUser(authUser);
    } else {
      return null;
    }
  }

  setNewAuthTagInSession(newAuthTag: PLAN_KEY) {
    this.authUser.auth_tags = newAuthTag;
    console.log('****', this.authUser);
    SessionUser.saveAuthUserInSession(this.authUser);
  }

  clearSession(): void {
    sessionStorage.clear();
  }

  private get authTag() {
    return this.authUser.auth_tags || '';
  }

  private get tagsList() {
    return this.authUser.auth_tags.split(',');
  }

  isAdmin(): boolean {
    return this.authTag && this.tagsList.includes(PLAN_KEY_VALUES.admin);
  }
  isStandard(): boolean {
    return this.authTag && this.tagsList.includes(PLAN_KEY_VALUES.standard);
  }
  // 先生専用機能が使える
  isTeacher(): boolean {
    return this.authTag && this.tagsList.includes(PLAN_KEY_VALUES.teacher);
  }
  isPro(): boolean {
    return this.authTag && this.tagsList.includes(PLAN_KEY_VALUES.pro);
  }
  isEnterprise(): boolean {
    return this.authTag && this.tagsList.includes(PLAN_KEY_VALUES.enterprise);
  }

  isClassRoomMember(): boolean {
    if (this.memberId) {
      return this.memberId !== AuthUser.NO_CLASS_MEMBER;
    } else {
      return false;
    }
  }

  get userId(): number {
    return this.authUser.user_id;
  }
  get memberId(): number {
    return this.authUser.member_id;
  }
  get memberName(): string {
    return this.authUser.member_name;
  }
  get userName(): string {
    return this.authUser.user_name;
  }
  get token(): string {
    return this.authUser.token;
  }
}
